export default "__VITE_ASSET__DvX3xuYQ__"